export const clampAmountToLimits = (amount, pm) => {
  if (!pm) return amount;
  const numAmount = Number(amount);
  if (!numAmount || Number.isNaN(numAmount)) return amount;

  if (pm.minAmount && numAmount < pm.minAmount) return pm.minAmount;
  if (pm.maxAmount && numAmount > pm.maxAmount) return pm.maxAmount;
  return amount;
};
